// Point the page's share metas (og:image / twitter:image / og:url) at a
// route-specific card. The SPA serves one index.html for every route, so
// static crawlers see the default card; this upgrades the tags for
// JS-rendering scrapers and share sheets that read the live DOM. Returns a
// cleanup that restores the defaults when the page unmounts.
const TAGS = [
  { attr: 'property', key: 'og:image' },
  { attr: 'name', key: 'twitter:image' },
  { attr: 'property', key: 'og:url' },
];

export function setShareMeta({ image, url }) {
  const values = { 'og:image': image, 'twitter:image': image, 'og:url': url };
  const restores = [];
  TAGS.forEach(({ attr, key }) => {
    const el = document.querySelector(`meta[${attr}="${key}"]`);
    const next = values[key];
    if (!el || !next) return;
    restores.push([el, el.getAttribute('content')]);
    el.setAttribute('content', next);
  });
  return () => restores.forEach(([el, prev]) => el.setAttribute('content', prev));
}
